
import { css } from '@emotion/react';

export const searchButtonCss = (theme) => css`
    && {
        display: flex;
        justify-content: center;
        width: 100%;
        background-color: ${theme.palette.primary.main};

        &:hover {
            background: ${theme.palette.primary.dark};
        }
    }
`;
